import { render } from "./BadRequest.vue?vue&type=template&id=7ff83c8c"
import script from "./BadRequest.vue?vue&type=script&lang=js"
export * from "./BadRequest.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__